import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import Dashboard from "./Dashboard";
import PublicPage from "./PublicPage";
import SampleDashboard from "./SampleDashboard";
import SamplePublicPage from "./samplePublicPage";
import PrivacyPage from "./PrivacyPage";
import TermsPage from "./TermsPage";
import ErrorBoundary from './ErrorBoundary';

const App = () => {
    return (
        <ErrorBoundary>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/:business_id" element={<PublicPage />} />
                    <Route path="/samplebiz" element={<SamplePublicPage />} />
                    <Route path="/sample-db" element={<SampleDashboard />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                </Routes>
            </Router>
        </ErrorBoundary>
    );
};

export default App;
